import clsx from 'clsx';
import { ModalPopup, Stack } from 'components';
import { useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { ScreenerTypeUppercase, ScreenerTypeLowercase } from 'store/screeener/screenerSlice';
import city from 'assets/png/city.png';
import { useParams } from 'react-router-dom';

import style from './screener.module.scss';
import { Impact } from './impact';
import { Other } from './other';

const screenerMapper: { [key in ScreenerTypeUppercase]: string } = {
  IMPACT: 'IMPaCT',
  OTHER: 'Other'
};

const Screener = () => {
  const { clientId } = useParams();
  const [selectedScreener, setSelectedScreener] = useState<ScreenerTypeLowercase | null>(null);
  const screeners = useAppSelector((state) => state.screener[clientId ?? '']?.screeners?.data);
  const areAllScreenersPopulated = screeners?.length === 2;

  const onSelectScreener = (screener: ScreenerTypeLowercase) => {
    setSelectedScreener(screener);
  };

  const onClearScreener = () => {
    setSelectedScreener(null);
  };

  return (
    <Stack width="100%" data-test-id="profile-snapshot">
      <div className={style.wrapper}>
        <p className={style.title}>Screener</p>
        {!areAllScreenersPopulated && (
          <span
            onClick={() => {
              if (screeners?.find((screener) => screener.type === 'IMPACT')) {
                onSelectScreener('other');
              } else {
                onSelectScreener('impact');
              }
            }}
            className={clsx('material-icons-outlined', style.editIcon)}
          >
            open_in_new
          </span>
        )}
      </div>
      {(screeners?.length ?? 0) > 0 && (
        <Stack display="flex" flexDirection="column" gap="8px" p="12px">
          {screeners?.map((screener) => (
            <button
              key={screener.type}
              onClick={() => onSelectScreener(screener.type.toLowerCase() as ScreenerTypeLowercase)}
              className={style.screener}
            >
              {screenerMapper[screener.type]}
            </button>
          ))}
        </Stack>
      )}
      {selectedScreener && (
        <ModalPopup
          open={selectedScreener !== null}
          customClassInsideContainer={style.modalWrapper}
        >
          <Stack display="flex" flexDirection="row" height="100%" width="100%">
            <Stack className={style.sidebar} height="100%" display="flex" justifyContent="end">
              <img src={city}></img>
            </Stack>
            <Stack p="24px" width="100%">
              <Stack
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <h3 className={style.modalTitle}>Screener</h3>
                <Stack display="flex" flexDirection="row" alignItems="center" gap="12px">
                  <div className={style.roadmapToggle}>
                    <div
                      onClick={(e) => {
                        setSelectedScreener('impact');
                      }}
                      className={clsx(
                        style.toggleItem,
                        selectedScreener === 'impact' && style.activeToggle
                      )}
                    >
                      <span>IMPaCT</span>
                    </div>
                    <div
                      onClick={() => {
                        setSelectedScreener('other');
                      }}
                      className={clsx(
                        style.toggleItem,
                        selectedScreener === 'other' && style.activeToggle
                      )}
                    >
                      <span>Other</span>
                    </div>
                  </div>
                  <div className={style.closeIcon} onClick={onClearScreener}>
                    <span className="material-icons">close</span>
                  </div>
                </Stack>
              </Stack>
              <Stack height="100%" minHeight={0} pt="36px">
                {selectedScreener === 'impact' && <Impact closeModal={onClearScreener} />}
                {selectedScreener === 'other' && <Other closeModal={onClearScreener} />}
              </Stack>
            </Stack>
          </Stack>
        </ModalPopup>
      )}
    </Stack>
  );
};

export default Screener;
